import React from "react";
import classes from "./askFilledNote.module.scss";

/**
 * The line at the top of a form Ask filled in (§2b A6): which fields Ask
 * filled, so the person checks them before saving.
 */
const AskFilledNote: React.FC<{ fields: string[]; source?: string }> = ({ fields, source = "by Ask" }) => {
    if (fields.length === 0) return null;
    return (
        <div className={classes.note} role="status" title="Ask only filled in the form. Nothing is saved until you press Save.">
            <i className="bi bi-stars" aria-hidden="true" />
            <span>Filled in {source}: {fields.join(", ")}. Check them, then save.</span>
        </div>
    );
};

export default AskFilledNote;
